export default __webpack_public_path__ + "./assets/product-feature1__db79861d49717e6bcca9951563e1b48c.png";